<div class="toolbar" fxLayout="row" fxLayoutAlign="space-between">
  <div fxLayout="row" fxLayoutAlign="start center">
    <dva-toolbar-sidenav-mobile-toggle (openSidenav)="openSidenav.emit()"></dva-toolbar-sidenav-mobile-toggle>

    <div [fxShow.gt-sm]="topNavigation$ | async" [fxShow.xs]="false" [routerLink]="['/']" class="toolbar-logo" fxShow>
      <img *ngIf="theme === 'dva-default'" src="assets/img/logo/hipervalidation.svg" alt=":hiperValidation" />
      <img *ngIf="theme === 'dva-dark'" src="assets/img/logo/hipervalidation-dark.svg" alt=":hiperValidation" />
    </div>
  </div>

  <div fxLayout="row">
    <button (click)="openHelp()" class="button toolbar-button" mat-button>
      <mat-icon>help</mat-icon>
    </button>

    <button *ngIf="theme === 'dva-default'" (click)="setTheme('dva-dark')" class="button toolbar-button" mat-button>
      <mat-icon>dark_mode</mat-icon>
    </button>

    <button *ngIf="theme === 'dva-dark'" (click)="setTheme('dva-default')" class="button toolbar-button" mat-button>
      <mat-icon>light_mode</mat-icon>
    </button>

    <dva-toolbar-fullscreen-toggle class="toolbar-button"></dva-toolbar-fullscreen-toggle>

    <dva-toolbar-notifications class="toolbar-button"></dva-toolbar-notifications>

    <dva-toolbar-user class="toolbar-button"></dva-toolbar-user>

    <dva-toolbar-progress class="toolbar-button" (openProgressPanel)="openProgressPanel.emit()"></dva-toolbar-progress>
  </div>
</div>
